/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const MidIntensityIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st0349{fill: ${color}}.st123478{fill:#fff}`}</style>
			<path
				className='st0349'
				d='M685 436.3v-.4c-.2-.9-1-1.6-1.9-1.6h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2c.9 0 1.7-.7 1.9-1.6v-4.4z'
			/>
			<g id='Rectangle_3901_00000045610909089413913330000009576213099884538281_'>
				<path
					className='st123478'
					d='M681 427.3h2c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2z'
					transform='translate(7 3)'
				/>
				<path
					className='st0349'
					d='M683 439.3h-2c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2zm-2-11c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-2z'
					transform='translate(7 3)'
				/>
			</g>
			<g id='Rectangle_3902_00000054965330392453066550000015734879322030028455_'>
				<path
					className='st123478'
					d='M681 427.3h2c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2z'
					transform='translate(14)'
				/>
				<path
					className='st0349'
					d='M683 442.3h-2c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2zm-2-14c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-11c0-.6-.4-1-1-1h-2z'
					transform='translate(14)'
				/>
			</g>
			<path
				className='st0349'
				d='M699 445.3c0-.3-.2-.5-.5-.5h-14.6c-.2-.8-1-1.5-1.9-1.5-.9 0-1.7.6-1.9 1.5h-.6c-.3 0-.5.2-.5.5s.2.5.5.5h.6c.2.9 1 1.5 1.9 1.5.9 0 1.7-.6 1.9-1.5h14.6c.3 0 .5-.3.5-.5zM7.2 10.8c0-.3-.1-.6-.2-.9-.3-.8-1.1-1.4-2-1.5H2.4C1.1 8.4 0 9.5 0 10.8v4.8C0 16.9 1.1 18 2.4 18H5c.9-.1 1.7-.7 2-1.5.1-.3.2-.6.2-.9v-4.8zM15.6 6c0-.3-.1-.6-.2-.9-.3-.8-1.1-1.4-2-1.5h-2.6C9.5 3.6 8.4 4.7 8.4 6v9.6c0 1.3 1.1 2.4 2.4 2.4h2.6c.9-.1 1.7-.7 2-1.5.1-.3.2-.6.2-.9V6z'
			/>
			<g id='Rectangle_3902_00000141426090159958185900000012729086764441829271_'>
				<path
					className='st123478'
					d='M5.2 0h2.4C8.9 0 10 1.1 10 2.4v13.2c0 1.3-1.1 2.4-2.4 2.4H5.2c-1.3 0-2.4-1.1-2.4-2.4V2.4C2.8 1.1 3.9 0 5.2 0z'
					transform='translate(14)'
				/>
				<path
					className='st0349'
					d='M7.6 18H5.2c-1.3 0-2.4-1.1-2.4-2.4V2.4C2.8 1.1 3.9 0 5.2 0h2.4C8.9 0 10 1.1 10 2.4v13.2c0 1.3-1.1 2.4-2.4 2.4zM5.2 1.2c-.7 0-1.2.5-1.2 1.2v13.2c0 .7.5 1.2 1.2 1.2h2.4c.7 0 1.2-.5 1.2-1.2V2.4c0-.7-.5-1.2-1.2-1.2H5.2z'
					transform='translate(14)'
				/>
			</g>
			<path
				className='st0349'
				d='M24 21.6c0-.3-.3-.6-.6-.6h-9.1c0-.1-.1-.2-.1-.3-.3-.8-1.1-1.4-2-1.5H12c-1.1 0-2 .8-2.3 1.8H.6c-.3 0-.6.3-.6.6s.3.6.6.6h9.1c.3 1 1.2 1.8 2.3 1.8h.2c.9-.1 1.7-.7 2-1.5 0-.1.1-.2.1-.3h9.1c.3 0 .6-.3.6-.6z'
			/>
		</svg>
	)
}

export default MidIntensityIcon
